import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
const store = new Vuex.Store({
	state: {
		hasLogin: false,
		userInfo: {}
	},
	mutations: {
		login(state, provider) {
			state.hasLogin = true;
			state.userInfo = provider;
			sessionStorage.setItem('user',provider) 
		},
		logout(state) {
			state.hasLogin = false;
			state.userInfo = {};
			sessionStorage.removeItem('user')
			
		}
	},
	actions: {
	
	}
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js